import LoadingDotsCSS from './LoadingDots.module.css';

export function LoadingDots() {
    return (
        <div className={LoadingDotsCSS["flashing-dots-container"]}>
            <div className={LoadingDotsCSS["dot-flashing"]}/>
        </div>
    );
}